import AbstractStorage from './AbstractStorage';

class SessionStorage extends AbstractStorage {
  static get<T>(key: string): T | null {
    const raw = sessionStorage.getItem(key);
    if (raw === null || raw === undefined) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  static set<T>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  static update<T>(key: string, field: string, value: T): void {
    const data = SessionStorage.get<Record<string, T>>(key);

    if (data) {
      data[field] = value;
      SessionStorage.set(key, data);
    } else {
      SessionStorage.set(key, {[field]: value});
    }
  }

  static remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  static clear(): void {
    sessionStorage.clear();
  }
}

export {SessionStorage};
